import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { Slide } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import { useDrawerContext } from '@hooks';
import { useTheme, useMediaQuery } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import { useStyles } from './styles';
import { RoomService, RestaurantMenu, ArrowBack } from '@material-ui/icons';

export default function ClippedDrawer() {
  const classes = useStyles();
  const { pathname } = useLocation();
  const { openDrawer, toggleDrawer } = useDrawerContext();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const stringifyPlaceData = localStorage.getItem('place');
  const parsedPlaceData = JSON.parse(stringifyPlaceData);

  const items = [
    {
      name: 'Service',
      Icon: RoomService,
      path: `/service/${parsedPlaceData.placeId}/orders`,
    },
    {
      name: 'Menu Management',
      Icon: RestaurantMenu,
      path: '/menu-management',
    },
  ];

  const otherItems = [
    {
      name: 'Back to Places',
      Icon: ArrowBack,
      path: '/',
    },
  ];
  return (
    <div className={classes.root}>
      {!matchesSM ? (
        <Slide
          timeout={500}
          direction="right"
          in={openDrawer}
          mountOnEnter
          unmountOnExit
        >
          <Drawer
            className={classes.drawer}
            variant="permanent"
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            {' '}
            <Toolbar />
            <div className={classes.drawerContainer}>
              <List>
                {items.map((Item, index) => (
                  <ListItem
                    component={Link}
                    to={Item.path}
                    button
                    classes={{ root: classes.root }}
                    className={`${classes.drawerItem} ${Item.path ===
                      pathname && classes.selected} `}
                    key={Item.name}
                  >
                    <ListItemIcon className={classes.drawerItem}>
                      {' '}
                      <Item.Icon />{' '}
                    </ListItemIcon>
                    <ListItemText primary={Item.name} />
                  </ListItem>
                ))}
              </List>
              <List className={classes.bottomContainer}>
                {otherItems.map((Item, index) => (
                  <ListItem
                    component={Link}
                    to={Item.path}
                    button
                    className={`${classes.drawerItem}`}
                    key={Item.name}
                  >
                    <ListItemIcon className={classes.drawerItem}>
                      <Item.Icon />
                    </ListItemIcon>
                    <ListItemText primary={Item.name} />
                  </ListItem>
                ))}
              </List>
            </div>
          </Drawer>
        </Slide>
      ) : (
        <Drawer
          // container={container}
          variant="temporary"
          anchor={'left'}
          open={openDrawer}
          onClose={toggleDrawer}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <List>
            {items.map((Item, index) => (
              <ListItem
                component={Link}
                to={Item.path}
                button
                className={`${classes.drawerItem} ${index === 0 &&
                  classes.selected} `}
                key={Item.name}
              >
                <ListItemIcon className={classes.drawerItem}>
                  {' '}
                  <Item.Icon />{' '}
                </ListItemIcon>
                <ListItemText primary={Item.name} />
              </ListItem>
            ))}
          </List>
          <List>
            {otherItems.map((Item, index) => (
              <ListItem
                component={Link}
                to={Item.path}
                button
                className={`${classes.drawerItem}`}
                key={Item.name}
              >
                <ListItemIcon className={classes.drawerItem}>
                  <Item.Icon />
                </ListItemIcon>
                <ListItemText primary={Item.name} />
              </ListItem>
            ))}
          </List>
        </Drawer>
      )}
    </div>
  );
}
